import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { DEFAULT_SCOPE, DEFAULT_BLOCKSTACK_HOST } from './constants';
import { getGlobalObject } from '@stacks/common';
export var AppConfig =
/*#__PURE__*/
function () {
  function AppConfig(scopes, appDomain, redirectPath, manifestPath, coreNode, authenticatorURL) {
    _classCallCheck(this, AppConfig);

    var _a;

    if (scopes === void 0) {
      scopes = DEFAULT_SCOPE.slice();
    }

    if (appDomain === void 0) {
      appDomain = (_a = getGlobalObject('location', {
        returnEmptyObject: true
      })) === null || _a === void 0 ? void 0 : _a.origin;
    }

    if (redirectPath === void 0) {
      redirectPath = '';
    }

    if (manifestPath === void 0) {
      manifestPath = '/manifest.json';
    }

    if (coreNode === void 0) {
      coreNode = undefined;
    }

    if (authenticatorURL === void 0) {
      authenticatorURL = DEFAULT_BLOCKSTACK_HOST;
    }

    this.appDomain = appDomain;
    this.scopes = scopes;
    this.redirectPath = redirectPath;
    this.manifestPath = manifestPath;
    this.coreNode = coreNode;
    this.authenticatorURL = authenticatorURL;
  }

  _createClass(AppConfig, [{
    key: "redirectURI",
    value: function redirectURI() {
      return "".concat(this.appDomain).concat(this.redirectPath);
    }
  }, {
    key: "manifestURI",
    value: function manifestURI() {
      return "".concat(this.appDomain).concat(this.manifestPath);
    }
  }]);

  return AppConfig;
}();